import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { forwardRef } from 'react';
import { Dialog as HeadlessDialog } from '@flywire/react-headlessui';
import { cx } from '../../utils';
import { Backdrop } from './Backdrop';
import { Description } from './Description';
import { Panel } from './Panel';
import { Title } from './Title';
export const useDialogClasses = ({ className, transition = true }) => {
    return cx('relative z-10', transition ? 'transition-opacity duration-125 ease-in data-[open="false"]:opacity-0' : '', className);
};
const DialogComponent = forwardRef(({ className, children, transition = true, isOpen = false, ...rest }, ref) => {
    const dialogClasses = useDialogClasses({ className, transition });
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);
    return (_jsx(HeadlessDialog, { ...rest, className: dialogClasses, isOpen: isOpen, ref: ref, children: children }));
});
DialogComponent.displayName = 'Dialog';
const Dialog = DialogComponent;
Dialog.Description = Description;
Dialog.Backdrop = Backdrop;
Dialog.Panel = Panel;
Dialog.Title = Title;
export { Dialog };
//# sourceMappingURL=Dialog.js.map